// Author YuJiaBei
// Date 2020-12-02 16:57:54

class EmAdmSysParam {
constructor({
        id = null,
        name = '',
        sysParameterKey = '',
        sysParameterValue = '',
        remark = ''}
= {}) {
    this.id = id;
    this.name = name;
    this.sysParameterKey = sysParameterKey;
    this.sysParameterValue = sysParameterValue;
    this.remark = remark;
}
}

function newEntity() {
return new EmAdmSysParam();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'name',
        label: 'label.em.admin.emAdmSysParam.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sysParameterKey',
        label: 'label.em.admin.emAdmSysParam.grid.sysParameterKey',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sysParameterValue',
        label: 'label.em.admin.emAdmSysParam.grid.sysParameterValue',
        sortable: true,
        form: {
        type: 'textarea'
        }
        },
        {
        key: 'remark',
        label: 'label.em.admin.emAdmSysParam.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    nameFilter : "",
    sysParameterKeyFilter : "",
    sysParameterValueFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'nameFilter',
        label: 'label.em.admin.emAdmSysParam.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'sysParameterKeyFilter',
        label: 'label.em.admin.emAdmSysParam.filter.sysParameterKey',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'sysParameterValueFilter',
        label: 'label.em.admin.emAdmSysParam.filter.sysParameterValue',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'name',
        label: 'label.em.admin.emAdmSysParam.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'sysParameterKey',
        label: 'label.em.admin.emAdmSysParam.entity.sysParameterKey',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'sysParameterValue',
        label: 'label.em.admin.emAdmSysParam.entity.sysParameterValue',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        },
        {
        key: 'remark',
        label: 'label.em.admin.emAdmSysParam.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {EmAdmSysParam, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
